// extracted by mini-css-extract-plugin
module.exports = {"starFilled":"styles_starFilled__acGjO","starEmpty":"styles_starEmpty__6yRZN","goldenSt":"styles_goldenSt__utLij"};